// Гостевая атрибуция по реф-коду барбера (спека §5: клиент по ссылке → email-регистрация → referred_by).
// Каталог читает `?ref=` (Task 21 landing `/c/[refCode]` линкует на `/?ref=<code>`) и кладёт код в
// localStorage; чекаут читает его отсюда и шлёт как `refCode` в теле `POST /api/checkout` →
// submitCheckout → ensureRetailCounterparty → attributeReferral. Без явного проброса через query/localStorage
// код никогда не попадал в тело чекаута — реферальная комиссия не начислялась (пойман Task 24 e2e).
const KEY = "briolin.refCode";

export function persistRefCode(refCode?: string): void {
  if (!refCode) return;
  try {
    localStorage.setItem(KEY, refCode);
  } catch {
    // localStorage недоступен (приватный режим/SSR-контекст) — атрибуция необязательна для покупки
  }
}

export function getStoredRefCode(): string | undefined {
  try {
    return localStorage.getItem(KEY) ?? undefined;
  } catch {
    return undefined;
  }
}
